import { ReactivateRoomActionTypes, ReactivateRoomState, REACTIVATE_ROOM_FAILURE, REACTIVATE_ROOM_REQUEST, REACTIVATE_ROOM_SUCCESS } from './types';

const defaultState: ReactivateRoomState = {
  isLoading: false,
  errorMessage: ""
};

export default function reactivateRoom(state = defaultState, action: ReactivateRoomActionTypes): ReactivateRoomState {
  switch (action.type) {
    case REACTIVATE_ROOM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REACTIVATE_ROOM_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case REACTIVATE_ROOM_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};